/**
 * Keeps the catalog-mode action link on the main product page in sync with the
 * selected variant. Patches the `variant-selects` custom element (defined in
 * global.js) from the outside instead of editing that file directly.
 */
(function () {
  const VariantSelects = customElements.get('variant-selects');
  if (!VariantSelects) return;

  const originalRenderProductInfo = VariantSelects.prototype.renderProductInfo;

  VariantSelects.prototype.renderProductInfo = function (mainProductSectionHtml, gallerySectionHtml) {
    originalRenderProductInfo.call(this, mainProductSectionHtml, gallerySectionHtml);

    const sectionId = this.dataset.section;
    const source = mainProductSectionHtml?.getElementById(`catalog-action-link-${sectionId}`);
    const destination = document.getElementById(`catalog-action-link-${sectionId}`);

    if (source && destination) {
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', source.classList.contains('hidden'));
    }
  };
})();
